import styled from 'vue3-styled-components';

export const ManageSidebarContainer = styled.div`
    width: 240px;
    height: calc(100vh - 50px);
    background-color: #f1f5f9;
    position: fixed;
    left: 0;
    top: 50px;
    border-right: 1px solid #e2e8f0;
`;

export const MenuContainer = styled.div`
    padding: 20px 10px;
`;

export const MenuCategory = styled.div`
    padding: 12px 16px;
    color: #1e293b;
    font-size: 17px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 20px;
    border-radius: 12px;
    margin: 20px 0;
    transition: all 0.3s ease;
    background: rgba(255, 255, 255, 0.7);
    border: 1px solid rgba(15, 76, 92, 0.05);

    &:hover {
        background: linear-gradient(135deg, rgba(251, 139, 36, 0.08) 0%, rgba(255, 255, 255, 0.9) 100%);
        transform: translateX(4px);
        box-shadow: 0 4px 15px rgba(251, 139, 36, 0.1);
    }
    
    &:active {
        transform: translateX(2px) scale(0.98);
        transition: all 0.1s ease;
    }
`;

export const SidebarHeader = styled.div`
    padding: 32px 24px;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    gap: 16px;
    position: relative;
`;

export const HeaderIcon = styled.div`
    width: 48px;
    height: 48px;
    background: linear-gradient(135deg, #fb8b24 0%, #e67e22 100%);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    box-shadow: 0 4px 15px rgba(251, 139, 36, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const HeaderTitle = styled.h2`
    font-size: 20px;
    font-weight: 600;
    color: #1e293b;
    margin: 0;
`;

export const MenuIcon = styled.div`
    width: 45px;
    height: 45px;
    background: rgba(251, 139, 36, 0.1);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #cc5803;
    border: 1px solid rgba(251, 139, 36, 0.2);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;